import script from "./CreateATalk.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateATalk.vue?vue&type=script&setup=true&lang=js"

import "./CreateATalk.vue?vue&type=style&index=0&id=113eb050&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-113eb050"]])

export default __exports__